import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconArrowLeft = forwardRef<SVGSVGElement, IconProps>(
  function IconArrowLeft(props, ref) {
    const { className, title, titleId, ...otherProps } = props
    const defaultClasses =
      "w-8 h-8 flex-shrink-0 transition-colors duration-150 ease-in focus:outline-none"
    const classes = mergeClasses(defaultClasses, className)

    return (
      <svg
        ref={ref}
        viewBox="0 0 32 32"
        fill="none"
        focusable="false"
        aria-hidden="true"
        tabIndex={-1}
        className={classes}
        aria-labelledby={titleId}
        {...otherProps}
      >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
          d="M20.8491 3.60009L10.2491 15.6001C10.1527 15.7111 10.0996 15.8531 10.0996 16.0001C10.0996 16.1471 10.1527 16.2891 10.2491 16.4001L20.8491 28.4001C20.9014 28.4594 20.965 28.5078 21.0362 28.5425C21.1073 28.5771 21.1847 28.5973 21.2637 28.602C21.3427 28.6066 21.4218 28.5956 21.4965 28.5695C21.5713 28.5435 21.6401 28.5029 21.6991 28.4501C21.8166 28.3429 21.8876 28.194 21.8969 28.0353C21.9062 27.8765 21.8532 27.7203 21.7491 27.6001L11.4991 16.0001L21.7491 4.40009C21.8532 4.27985 21.9062 4.1237 21.8969 3.96492C21.8876 3.80614 21.8166 3.65728 21.6991 3.55009C21.6401 3.4973 21.5713 3.4567 21.4965 3.43063C21.4218 3.40456 21.3427 3.39353 21.2637 3.39818C21.1847 3.40283 21.1073 3.42306 21.0362 3.45771C20.965 3.49237 20.9014 3.54075 20.8491 3.60009Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
